import clsx from 'clsx';
import React, { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { FakeLink } from '@/core/FakeLink';
import { canUseMemo } from '@/formbuilder/formbuilder.utilities';
import { Icon } from '@seeqdev/qomponents';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface ClickableLinkIF extends ValidatingFormComponent<string> {
  component: 'ClickableLinkFormComponent';
  linkTestId?: string;
  icon?: ComponentProps<typeof Icon>['icon'];
  linkAction?: () => void;
}

const ClickableLinkFormComponentUnwrapped = (props: ClickableLinkIF) => {
  const { value, linkAction, icon, extraClassNames = '', linkTestId = 'linkTestId' } = props;
  const { t } = useTranslation();
  const translationKey = value ?? '';

  return (
    <div className={clsx(extraClassNames)}>
      <FakeLink onClick={linkAction} testId={linkTestId}>
        {icon && <Icon icon={icon} extraClassNames="mr5" />}
        <span>{t(translationKey)}</span>
      </FakeLink>
    </div>
  );
};
export const ClickableLinkFormComponent = React.memo(ClickableLinkFormComponentUnwrapped, canUseMemo);
